import { AuthenticationData } from './Definitions';

/**
 * @class - abstract base class for gateway authenticators
 * logon() - used to logon to corresponding gateway type
 */
export default abstract class GatewayAuthenticatorBase {
	protected receiverIdUrl: URL;

	constructor(serverUrl: URL) {
		this.receiverIdUrl = serverUrl;
	}

	abstract logon(): Promise<AuthenticationData>;
	abstract logoff(): Promise<void>;
}
